<template>
  <div v-if="quoform.cpastureinfo!=''">
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-finance"></i>订单确认</b></div>
      <div class=' contijiao wkbmf loaded' v-if="quoform.cvencheck=='已确认'">
        <div class='stamp stamp1'> </div>
      </div>
      <div class="text item text-center" style="width:100%;height:60px;">
        <div class="pull-right" style="margin-bottom: 15px">
          <!-- <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain size="medium" @click.native="GetInquiryListInfo('')">全部要货详情</el-button>
          </Debounce> -->
          <!-- <el-button type="primary" plain size="medium" @click="PriceSubmit" :disabled="quoform.cvencheck=='已确认'">同意卸货</el-button> -->
          <!-- <el-button type="primary" plain size="medium" @click="PriceSubmitNO" :disabled="quoform.cvencheck=='已确认'">不同意</el-button> -->
          <!-- <el-button type="info" plain size="medium" @click="printpage()">订单打印</el-button> -->
          <!-- <el-upload style="display:inline-block;margin:0 10px" action="#" v-if="quoform.cmastupfile=='是'" :disabled="quoform.cvencheck=='已确认'" ref="uploadFail" :show-file-list="false" :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail" :accept="typeaccept">
            <el-button type="success" size="medium" plain :disabled="quoform.cvencheck=='已确认'">回执单上传({{typeaccept}})</el-button>
          </el-upload> -->
          <!-- <el-button type="warning" plain @click.native="GetHTFileUrl()" v-if="quoform.cmastupfile=='是'" size="medium">预览</el-button> -->
          <!-- <el-button type="info" plain size="medium" @click="returnpage">返回</el-button> -->
          <el-button type="info" plain size="medium" @click="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click="returnpage('2')">返回首页</el-button>
        </div>
      </div>
      <!--  -->
      <div style="width:100%">
        <el-form :inline="true" :model="quoform" class="demo-form-inline itemwidth infodata" label-width="100px">
          <el-form-item label="订单号">
            <el-input v-model="quoform.csapcode" placeholder="订单号" disabled></el-input>
          </el-form-item>
          <el-form-item label="过磅单号">
            <el-input v-model="quoform.cgbdh" placeholder="过磅单号" disabled></el-input>
          </el-form-item>
          <el-form-item label="公司信息" class="cremark">
            <el-input v-model="quoform.cztname" placeholder="公司信息" disabled></el-input>
          </el-form-item>
          
          <el-form-item label="物料信息" class="cremark">
            <el-input v-model="quoform.cinvname" placeholder="物料信息" disabled></el-input>
          </el-form-item>
          <el-form-item label="检验结果">
            <el-input v-model="quoform.cxyjg" placeholder="检验结果" disabled></el-input>
          </el-form-item>
          <el-form-item label="奖罚金额">
            <el-input v-model="quoform.cjfmoney" placeholder="奖罚金额" disabled></el-input>
          </el-form-item>

          <el-form-item label="车牌号">
            <el-input v-model="quoform.ccarcode" placeholder="车牌号" disabled></el-input>
          </el-form-item>
         
          <el-form-item label="检验人员">
            <el-input v-model="quoform.ccheckperson" placeholder="检验人员" disabled></el-input>
          </el-form-item>
           <el-form-item label="备注" class="cremark">
            <el-input v-model="quoform.cremark" placeholder="备注" disabled></el-input>
          </el-form-item>
           <el-form-item label="过磅日期"  class="cremark">
            <el-input v-model="quoform.dgbdate" placeholder="过磅日期" disabled></el-input>
          </el-form-item>
          <el-form-item label="检验时间"  class="cremark">
            <el-input v-model="quoform.dchecktime" placeholder="检验时间" disabled></el-input>
          </el-form-item>
        </el-form>
      </div>

    </el-card>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix"><b><i class="el-icon-s-finance"></i>订单信息</b>
        <font class="ming">具体要货日期请查看要货详情</font>
      </div>
      <el-table :data="tableData" style="width: 100%; background: transparent" max-height="420" class="tb-edit tablecenter" show-summary :summary-method="getSummaries" border highlight-current-row :header-cell-style="{ background: '#eef1f6'}">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column label="指标" prop="cnormname" width="300px" />
        <el-table-column label="检验值" prop="cinspectionvalue" width="300px" />
        <el-table-column label="奖罚金额" prop="cjfmoney_inv" width="300px" />
        <el-table-column label="备注" prop="cremark" min-width="400px" />
      </el-table>
    </el-card>
  </div>
</template>
<style>
.el-table .success-row {
  background: #59ff00;
}
</style>
<script>
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { printExcel } from "../../../../utils/config";
import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
export default {
  data() {
    return {
      quoform: {
        csapcode: "",
        cpastureinfo: "",
        dpurtime: "",
        dvencheckend: "",
        curgent: "",
        cisreceipt: "",
        cmaker: "",
      },
      tableData: [],
      tablequiry: [],
      suprow: {},
      fileListFail: [],
      dialogFormVisible: false,
      typeaccept: "",
      met: [],
      main: [],
      zongji: 0,
      bbbg: false,
      previnformdata: {},
    };
  },
  created() {
    if (this.$route.params.rows) {
      this.suprow = this.$route.params.rows;
      sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));
      this.previnformdata = this.$route.params.informdata;
      sessionStorage.setItem(
        "informdata",
        JSON.stringify(this.$route.params.informdata)
      );
    } else {
      this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
      this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
    }
    if (this.suprow.id) {
      console.log(this.suprow);
      this.GitPurchaseorderInfo();
    }
  },
  methods: {
    // 求和
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "小计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));

        if (index == 5 || index == 8) {
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += "";
          } else {
            sums[index] = "N/A";
          }
        }
      });

      return sums;
    },
    // 获取信息
    GitPurchaseorderInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetSupplierQCInfo",
        data: { keyId: this.suprow.id },
      }).then((res) => {
        console.log(res, "获取信息结果");
        this.loading = false;
        if (res.data.Success) {
          this.quoform = res.data.Data.mainTable[0];
          this.tableData = res.data.Data.invTable;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 删除待办事项中的信息
    removerp() {
      RemovePruchaseToDo({
        KeyValue: this.suprow.id,
      }).then((res) => {
        console.log(res);
      });
    },
    // 返回
    returnpage(type) {
      sessionStorage.removeItem("params");
      if (type == "1") {
        this.$router.push({
          path: "/OrderConfirmList/OrderConfirmList",
          query: { informdata: this.previnformdata },
        });
      } else {
        this.$router.push({ path: "/home" });
      }
    },

  },
};
</script>
<style scoped>
.itemwidth .el-input {
  width: 160px;
}

.itemwidth .el-select {
  width: 160px;
}
.cremark .el-input {
  width: 430px;
}
</style>